import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DateUtilsService, SelectFieldOption, TranslationService } from '@sdbn/common';
import { AreaGateLogRepresentation, AreaGateLogSelection } from '../area-gate-log.model';
import { AppClientConfiguration, HttpService } from '@sdbn/appclient';

@Component({
  selector: 'app-area-gate-log-administration',
  templateUrl: './area-gate-log-administration.component.html',
  styleUrls: ['./area-gate-log-administration.component.scss']
})
export class AreaGateLogAdministrationComponent implements OnInit {

  dataSource = new MatTableDataSource(new Array<AreaGateLogRepresentation>());

  columnsToDisplay = ['date', 'gate', 'direction', 'event', 'filler'];

  selected: AreaGateLogRepresentation;

  selection = new AreaGateLogSelection();

  types: Array<SelectFieldOption>;

  fromGroup = new FormGroup({
    dateFrom: new FormControl(null, []),
    dateUntil: new FormControl(null, []),
    type: new FormControl(null, [])
  });

  constructor(
    public translationService: TranslationService,
    private dateUtils: DateUtilsService,
    private httpService: HttpService,
    private appClientConfiguration: AppClientConfiguration
  ) { }

  ngOnInit(): void {

    let types = new Array<SelectFieldOption>();
    types.push(new SelectFieldOption({ labelDictionaryKey: 'tmc-common.common.enum.area-gate-log-event.numberplate_recognition_failed', value: 'numberplate_recognition_failed' }));
    this.types = types;

    this.selection.dateFrom = this.dateUtils.convertDateToTimestamp(new Date());
    this.selection.dateUntil = this.dateUtils.convertDateToTimestamp(new Date());
    this.selection.type = 'numberplate_recognition_failed';

    this.fromGroup.patchValue({
      dateFrom: this.dateUtils.parseDateFromTimestamp(this.selection.dateFrom),
      dateUntil: this.dateUtils.parseDateFromTimestamp(this.selection.dateUntil),
      type: this.selection.type,
    });

    this.fromGroup.valueChanges.subscribe(value => {
      this.selection.dateFrom = this.dateUtils.convertDateToTimestamp(value.dateFrom);
      this.selection.dateUntil = this.dateUtils.convertDateToTimestamp(value.dateUntil);
      this.selection.type = value.type;
      console.log('values changed', value, this.selection);
    });

    this.loadLogEntries();

  }

  private loadLogEntries() {
    this.httpService.postWithContext<AreaGateLogRepresentation[]>(this.appClientConfiguration.serverURLRoot + '/tmc-common/areaGateLog/findLogs',
      this.selection).subscribe(response => {

        let rows = new Array<AreaGateLogRepresentation>();
        for (const entry of response) {
          rows.push(new AreaGateLogRepresentation(entry));
        }
        this.dataSource = new MatTableDataSource(rows);


      }, error => {
      });
  }

  sortChanged($event: Sort) {
  }

  onClickRow(selected: AreaGateLogRepresentation) {
    this.selected = selected;
  }

  public refresh() {
    this.loadLogEntries();
  }

}
